import Switch, { SwitchProps } from '@material-ui/core/Switch'
import React from 'react'
import { styles } from './styles'

export interface IOSSwitchProps extends SwitchProps {}

const IOSSwitch = (props: IOSSwitchProps) => {
  const classes = styles()

  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  )
}

export default IOSSwitch
